var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', [_c('div', {
    staticClass: "dot-title",
    style: {
      color: _vm.color
    }
  }, [_vm._v(" 导入数据 ")]), _vm.isWaiting ? _c('div', {
    staticClass: "dot-tip el-color-gray-6"
  }, [_vm._v(" 等待文件上传完毕后自动导入数据 ")]) : _vm._e(), _vm.isImporting ? _c('div', [_c('el-progress', {
    attrs: {
      "percentage": _vm.importedNum ? 100 : 0
    }
  }), _c('div', {
    staticClass: "dot-tip el-color-gray-7"
  }, [_vm._v(" 本次共导入数据" + _vm._s(_vm.importedNum) + "条 ")])], 1) : _vm._e(), _vm.isComplete ? _c('div', {
    staticClass: "dot-tip el-color-success-7"
  }, [_vm._v(" 数据导入完成 ")]) : _vm._e(), _vm.isFailed ? _c('div', {
    staticClass: "dot-tip el-color-danger-7"
  }, [_vm._v(" 数据导入失败 ")]) : _vm._e()]);
};

var staticRenderFns = [];
export { render, staticRenderFns };